import React from 'react';
import Styles from './styles.module.scss';

export class PrimaryPinkButton extends React.Component {
  render() {
    return (
      <button
        className={Styles['fill-pink-button']}
        type="click"
        onClick={this.props.onClick}
        {...this.props}
      >
        {this.props.children}
      </button>
    );
  }
}
